import React from "react";

type RebateInfoProps = {
    district: string;
    category: string;
    supplier: string;
    backToZero: string;
};

const RebateInfo: React.FC<RebateInfoProps> = ({
    district,
    category,
    supplier,
    backToZero,
}) => {
    return (
        <div className="w-full bg-white rounded-md shadow-sm">
            {/* green line and title */}
            <div className="px-3 pt-1 pb-1 text-fs16 font-bold">
                Rebate Information
            </div>
            <div className="h-[3px] bg-[#a6ce39] rounded-t-md" />

            {/* 2-row, 4-column grid */}
            <div className="grid grid-cols-4 text-xs border border-gray-300 ">
                {/* Row 1 */}
                <div className="border-t border-[#bebebe] bg-[#ebeee5] px-2 py-1 font-semibold">
                    District
                </div>
                <div className="border-t border-l border-[#bebebe] bg-white px-2 py-1">
                    {district}
                </div>
                <div className="border-t border-l border-[#bebebe] bg-[#ebeee5] px-2 py-1 font-semibold">
                    Category
                </div>
                <div className="border-t border-l border-[#bebebe] bg-white px-2 py-1">
                    {category}
                </div>

                {/* Row 2 */}
                <div className="border-t border-[#bebebe] bg-[#ebeee5] px-2 py-1 font-semibold">
                    Supplier
                </div>
                <div className="border-t border-l border-[#bebebe] bg-white px-2 py-1">
                    {supplier}
                </div>
                <div className="border-t border-l border-[#bebebe] bg-[#ebeee5] px-2 py-1 font-semibold">
                    Back to Zero?
                </div>
                <div className="border-t border-l border-[#bebebe] bg-white px-2 py-1">
                    {backToZero}
                </div>
            </div>
        </div>
    );
};

export default RebateInfo;